export type InventoryMovementMode = 'sales' | 'consumed';

const STORAGE_KEY_PREFIX = 'control-centre-inventory-movement-mode';
const LEGACY_STORAGE_KEY = 'control-centre-inventory-movement-mode';

function storageKey(businessId?: string): string {
  return businessId ? `${STORAGE_KEY_PREFIX}-${businessId}` : LEGACY_STORAGE_KEY;
}

export function readInventoryMovementMode(businessId?: string): InventoryMovementMode {
  try {
    if (businessId) {
      const stored = localStorage.getItem(storageKey(businessId));
      if (stored === 'sales' || stored === 'consumed') return stored;
    }

    const legacy = localStorage.getItem(LEGACY_STORAGE_KEY);
    if (legacy === 'sales' || legacy === 'consumed') return legacy;
  } catch {
    // ignore quota / private mode
  }
  return 'sales';
}

export function writeInventoryMovementMode(
  mode: InventoryMovementMode,
  businessId?: string
): void {
  try {
    localStorage.setItem(storageKey(businessId), mode);
  } catch {
    // ignore quota / private mode
  }
}
